import { Component, Input } from '@angular/core';

@Component({
    selector: 'influencer-module-placeholder',
    templateUrl: './influencer-module-placeholder.component.html',
    styleUrls: ['./influencer-module-placeholder.component.scss']
})
export class InfluencerModulePlaceholderComponent {
    @Input() width = 360;
    @Input() isFetchingData: boolean;
    @Input() hasNoData: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-module-placeholder/influencer-module-placeholder.component.ts